import LegalLayout from "./LegalLayout";
import { COMPANY } from "@/legal/companyInfo";

const addr = `${COMPANY.address.street}, ${COMPANY.address.zip} ${COMPANY.address.city}, ${COMPANY.address.country}`;

export default function LegalNotice() {
  return (
    <LegalLayout title="Mentions légales" subtitle={`Informations légales relatives au site ${COMPANY.website}.`}>
      <section>
        <h2>Éditeur du site</h2>
        <p>
          <strong>{COMPANY.legalName}</strong><br/>
          Forme juridique : {COMPANY.legalForm}<br/>
          Numéro IDE : {COMPANY.ide}<br/>
          Inscription : registre du commerce du canton du Valais<br/>
          Siège social : {addr}<br/>
          Site web : <a href={COMPANY.website}>{COMPANY.website}</a><br/>
          Email : <a href={`mailto:${COMPANY.contactEmail}`}>{COMPANY.contactEmail}</a>
        </p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>Le service (application, base de données et sauvegardes) est hébergé par <strong>Emergent Labs Inc.</strong>, États-Unis, sur une base de données MongoDB Atlas située aux États-Unis.</p>
        <p>{COMPANY.vatNote}</p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des éléments du site (textes, logos, images, code) est protégé par le droit d'auteur suisse. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>Pour toute question : <a href={`mailto:${COMPANY.contactEmail}`}>{COMPANY.contactEmail}</a></p>
      </section>
    </LegalLayout>
  );
}
